export const ReferralsTokenKey = 'referrals.token'
export const ReferralsSessionKey = 'referrals.session'
